import { SET_VIEWED_USER } from './viewed-user-actions';

export default function viewedUser(state = null, action) {
  switch (action.type) {
    case SET_VIEWED_USER:
      return action.payload;
    default:
      return state;
  }
}
